(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/store/atoms.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/store/atoms.js');
'use strict';

const {
  atom
} = jotai;
const {
  activeSelfExclusions,
  isNaExcluded
} = svs.self_exclusion_react.data;
const selfExclusionAtoms = {
  activeExclusionsAtom: atom(activeSelfExclusions),
  isNaExcludedAtom: atom(isNaExcluded)
};
svs.selfExclusion.store.selfExclusionAtoms = selfExclusionAtoms;

 })(window);